module.exports = __webpack_public_path__ + "static/media/Glide-270x270.5ac19dff.png";